// Структура турнирной сетки на 22 участника (двойное выбывание).
// Сетка задана на фронте; бэкенд присылает только матчи с их кодами.
//
// Коды матчей (латиница), как они хранятся в базе:
//   T1-3  — тур 1, матч 3
//   B3-1  — верхняя сетка, тур 3, матч 1
//   B2    — бай верхней сетки во 2-м туре (в матче один игрок)
//   H4-2  — нижняя сетка, тур 4, матч 2
//   H4    — бай нижней сетки в 4-м туре
//   F     — финал

export const ROUNDS = [
    ['Тур 1', '1/32'],
    ['Тур 2', '1/16'],
    ['Тур 3', '1/8'],
    ['Тур 4', '1/4'],
    ['Тур 5', '1/2'],
    ['Тур 6', ''],
    ['Тур 7', ''],
    ['Тур 8', 'финал'],
];

export const ROUND1_MATCHES = 11;

// bye — есть ли в туре бай, matches — сколько пар
export const UPPER = {
    2: { bye: true, matches: 5, count: '11 игроков' },
    3: { bye: false, matches: 3, count: '6 игроков' },
    4: { bye: true, matches: 1, count: '3 игрока' },
    5: { bye: false, matches: 1, count: '2 игрока' },
};

export const LOWER = {
    2: { bye: true, matches: 5, count: '11 игроков', source: 'проигравшие тура 1' },
    3: { bye: true, matches: 5, count: '11 игроков', source: '5 + бай + 5 из верхней' },
    4: { bye: true, matches: 4, count: '9 игроков', source: '5 + бай + 3 из верхней' },
    5: { bye: false, matches: 3, count: '6 игроков', source: '4 + бай + 1 из верхней' },
    6: { bye: false, matches: 2, count: '4 игрока', source: '3 своих + 1 из верхней' },
    7: { bye: false, matches: 1, count: '2 игрока', source: 'победители тура 6' },
};

// тур верхней сетки -> [сколько проигравших опускается, в какой тур нижней]
export const DROPS = { 2: [5, 3], 3: [3, 4], 4: [1, 5], 5: [1, 6] };

// тур нижней сетки -> сколько игроков выбывает
export const OUTS = { 2: 5, 3: 5, 4: 4, 5: 3, 6: 2, 7: 1 };

export const FINAL_CODE = 'F';
export const UPPER_FINAL_CODE = 'B5-1';

// bracket: 'T' | 'B' | 'H'; index не задан — это бай
export const matchCode = (bracket, round, index) =>
    index == null ? `${bracket}${round}` : `${bracket}${round}-${index}`;

const RU = { T: 'Т', B: 'В', H: 'Н' };

// Подпись на карточке матча: В3·2, Н4, Т1·5
export const matchLabel = (bracket, round, index) =>
    index == null ? `${RU[bracket]}${round}` : `${RU[bracket]}${round}·${index}`;
